import type { WidgetConfig } from './model';

/** The widget's configuration when no attribute overrides it — shared with the live recorder in
 *  `test/drift/record.ts`, so a recorded turn is asked exactly the way the widget asks. */
export const DEFAULTS: WidgetConfig = {
  baseUrl: 'https://oi.destination.one',
  apiKey: '',
  model: 'smart-mobility-niedersachsen',
  // Die offene Tür (`server:meta-open-data`) ist seit 14.09.2026 NICHT mehr dabei. Sie war drin,
  // weil nur sie Tour-Geometrien lieferte; seit Sprint 770 trägt `get_tourism_details` den Verlauf
  // selbst. Ihre Treffer kamen ohne `hub_detail_url` (fremder Tool-Server, kein Backend von uns)
  // und mit dem Plattformnamen statt dem Hub-Namen — Bubble ohne entdecke-nds-Link, „Quelle:
  // destination.one" im Text. Über das Attribut `tool-ids` bleibt sie zuschaltbar.
  toolIds: ['server:mcp:tmn-mobility-mcp', 'server:mcp:tmn-tourism-mcp'],
  tilesUrl: 'https://ai.projektionisten.eu/tiles/niedersachsen.pmtiles',
  extendedHint: true,
  deleteChats: false,
  pollMs: 2500,
  // Not a total budget — a complex family/trip query makes many tool calls and can run several
  // minutes while still making progress. `timeoutMs` is the STALL window (no change at all); a
  // growing answer never times out (openwebui.ts). Raised 180→300 s so a long "thinking" gap
  // between tool batches doesn't cut a working answer; the hard ceiling is 4× (20 min).
  timeoutMs: 300_000,
  title: 'Reise- und Mobilitätsassistent',
  placeholder: 'Wie komme ich morgen nach Celle – und was lohnt sich dort?',
  // where the long one does not fit the input (measured, chat.ts); a host's own `placeholder` stands for both
  placeholderShort: 'Wie komme ich nach Celle?',
  // EU-KI-Verordnung Art. 50 Abs. 1: wer mit einem KI-System spricht, muss das wissen.
  // Der Hinweis steht sichtbar über dem Verlauf, nicht in einem Aufklapper — und er sagt
  // dazu, was hier praktisch schiefgehen kann, statt nur „kann Fehler machen".
  aiNotice: 'Die Antworten erzeugt eine KI. Sie kann sich irren – Abfahrtszeiten, Preise und Öffnungszeiten vor der Reise prüfen.',
  // in a chat up to 440 px wide (a phone) the head says it in one line at 320 px, and the footer
  // under the input goes (Stakeholder 29.10.2026)
  aiNoticeShort: 'KI-Antworten – Angaben vor der Reise prüfen.',
  aiNoticeHref: '',
  // one per kind of question the introduction names: connections, departures, sights — the
  // connection goes elsewhere than the placeholder's, so the list does not repeat it
  examples: ['Wie komme ich von Hannover nach Goslar?', 'Was fährt gleich ab Kröpcke?', 'Welche Museen gibt es in Oldenburg?'],
  home: { lat: 52.65, lon: 9.4, zoom: 6.6 },
  map: 'auto',
  mapToggle: true,
  // in the flow of a page one finger scrolls the page; embed.html as a page of its own says `greedy`
  gestures: 'cooperative',
};
